import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export default function CadisLoader(props: CircularProgressProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <CircularProgress {...props} />
    </Box>
  );
}